"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = void 0;
const yup_1 = require("yup");
exports.validationSchema = (0, yup_1.object)().shape({
    timeLagBeforeRelease: (0, yup_1.number)()
        .typeError("form.validations.badInput")
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .min(0, "form.validations.rangeUnderflow"),
    commission: (0, yup_1.number)()
        .typeError("form.validations.badInput")
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .max(100, "form.validations.rangeOverflow")
        .min(0, "form.validations.rangeUnderflow"),
});
//# sourceMappingURL=validation.js.map